/**
 * 本地缓存Key
 */

// 管理员资料
export const ADMIN_INFO = 'rmwAdminInfo'

// WEB端布局配置
export const STORE_CONFIG = 'rmwStoreConfig_v2'
// 后台标签页
export const STORE_TAB_VIEW_CONFIG = 'rmwStoreTabViewConfig'

// 切换到手机端前的上次布局方式
export const BEFORE_RESIZE_LAYOUT = 'rmwBeforeResizeLayout'

export const RESOURCE_FAILED_RELOAD_KEY = 'rmwResourceFailedReload'
